import Vue from 'vue';

// Load in mapbox dependencies
require('./mapbox');

// Load components into vue instance
require('./components');

window.app = new Vue({
    el: '#app',
});